<unity-container>
  @if (loading) {
    <div>
      <app-loader></app-loader>
    </div>
  }

  @if (!loading) {
    <div>
      <!-- Loading Bar for Delete Button-->
      @if (deleteLoading) {
        <div>
          <div class="em-c-modal em-js-modal-only" id="">
            <div class="em-c-modal__window em-js-modal-window">
              <div class="em-c-modal__header">
                <h3 class="em-c-modal__title">Checking Client Mapping</h3>
                <button
                  class="em-c-btn em-c-btn--bare em-c-modal__close-btn em-js-modal-close-trigger"
                >
                  <span class="em-c-btn__text">Close</span>
                </button>
                <!-- end em-c-btn -->
              </div>
              <!-- end em-c-modal__header -->
              <div
                class="em-c-modal__body em-c-text-passage em-c-text-passage--small"
              >
                <div
                  class="em-c-field em-c-progress-bar em-c-progress-bar--indeterminate em-u-max-width-100"
                >
                  <div class="em-c-progress-bar__bar">
                    <span
                      class="em-c-progress-bar--indeterminate__value"
                    ></span>
                  </div>
                </div>
              </div>
              <!-- end em-c-modal__body -->
            </div>
            <!-- end em-c-modal__window -->
          </div>
          <!-- end em-c-modal -->
        </div>
      }
      <!-- End : Loading Bar for Delete Button-->
      @if (!deleteLoading) {
        <div>
          <!-- Error at Delete Button -->
          @if (deleteError) {
            <div class="em-c-modal em-js-modal" id="modal">
              <div class="em-c-modal__window em-js-modal-window">
                <div class="em-c-modal__header">
                  <h3 class="em-c-modal__title">Delete Error</h3>
                  <button
                    class="em-c-btn em-c-btn--bare em-c-modal__close-btn em-js-modal-close-trigger"
                    (click)="closeError()"
                  >
                    <span class="em-c-btn__text">Close</span>
                  </button>
                  <!-- end em-c-btn -->
                </div>
                <!-- end em-c-modal__header -->
                <div
                  class="em-c-modal__body em-c-text-passage em-c-text-passage--small"
                >
                  <div class="em-c-alert em-c-alert--error" role="alert">
                    <svg class="em-c-icon em-c-icon--small em-c-alert__icon">
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="../../images/em-icons.svg#circle-exclamation-mark"
                      ></use>
                    </svg>
                    <div class="em-c-alert__body">
                      Client {{ currentClientText }} still exist in entitlement
                      mapping, please delete mapping first.
                    </div>
                  </div>
                  <!-- end em-c-alert -->
                </div>
                <!-- end em-c-modal__body -->
              </div>
              <!-- end em-c-modal__window -->
            </div>
          }
          <!-- end em-c-modal -->
          <!-- End : Error at Delete Button -->
          <!-- Confirm Delete -->
          @if (showConfirmPopup) {
            <div class="em-c-modal em-c-modal--alert em-js-modal-only" id="">
              <div class="em-c-modal__window em-js-modal-window">
                <div class="em-c-modal__header">
                  <h3 class="em-c-modal__title">Confirm Delete Client</h3>
                  <button
                    class="em-c-btn em-c-btn--bare em-c-modal__close-btn em-js-modal-close-trigger"
                    (click)="closePopUp()"
                  >
                    <div class="em-c-btn__inner">
                      <svg
                        class="em-c-icon em-c-icon--small em-c-btn__icon"
                        data-em-icon-path="../../images/em-icons.svg"
                      >
                        <use
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="../../images/em-icons.svg#x-filled"
                        ></use>
                      </svg>
                    </div>
                  </button>
                  <!-- end em-c-btn -->
                </div>
                <!-- end em-c-modal__header -->
                <div
                  class="em-c-modal__body em-c-text-passage em-c-text-passage--small"
                >
                  Are you sure to remove this client:&nbsp;{{
                    currentClientText
                  }}&nbsp;?
                  <div
                    class="em-c-btn-group em-c-modal--alert em-js-modal-only"
                  >
                    <button
                      class="em-c-btn em-c-btn--primary em-js-modal-confirm-trigger"
                      (click)="deleteClient(currentClient)"
                    >
                      <span class="em-c-btn__text">OK</span>
                    </button>
                    <!-- end em-c-btn -->
                    <button
                      class="em-c-btn em-c-btn--secondary em-js-modal-cancel-trigger"
                      (click)="closePopUp()"
                    >
                      <span class="em-c-btn__text">Cancel</span>
                    </button>
                    <!-- end em-c-btn -->
                  </div>
                  <!-- end em-c-btn-group -->
                </div>
                <!-- end em-c-modal__body -->
              </div>
              <!-- end em-c-modal__window -->
            </div>
          }
          <!-- end em-c-modal -->
          <!-- End : Confirm Delete -->
        </div>
      }
      <div class="em-c-toolbar em-c-toolbar--order">
        <div class="em-c-toolbar__item">
          <div class="em-c-dropdown-check em-js-dropdown-check">
            <h4>Client list</h4>
          </div>
          <!-- End em-c-dropdown-check -->
        </div>
        <!-- end em-c-toolbar__item -->
        <div class="em-c-toolbar__item em-is-aligned-right">
          <div class="em-c-btn-group">
            <div class="em-c-field__body em-c-field em-is-readonly">
              <input
                class="em-c-input em-js-input"
                placeholder="Search"
                [(ngModel)]="searchString"
              />
              <svg
                class="em-c-icon em-c-icon--medium em-c-field__icon em-u-clickable"
                (click)="clearSearch()"
              >
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#circle-x"
                ></use>
              </svg>
            </div>
          </div>
          <!-- end em-c-btn-group -->
        </div>
        <!-- end em-c-toolbar__item -->
      </div>
      <unity-table>
        <thead unity-table-head>
          <tr unity-table-head-row>
            <th scope="col" unity-table-head-cell>Client ID</th>
            <th scope="col" unity-table-head-cell>Name</th>
            <th scope="col" unity-table-head-cell></th>
          </tr>
        </thead>
        @for (
          client of storeService.clients$ | async | clientFilter: searchString;
          track client
        ) {
          <tbody unity-table-body>
            <tr unity-table-row>
              <td unity-table-cell>
                {{ client.id }}
              </td>
              <td unity-table-cell>
                {{ client.name }}
                @if (showDeletedBadge(client)) {
                  <unity-badge color="caution"> Deleted </unity-badge>
                }
              </td>
              <td
                unity-table-cell
                class="em-u-text-align-center"
                style="padding: 0; vertical-align: middle"
              >
                <unity-button-bar>
                  <li unity-button-bar-item>
                    <button
                      unity-button
                      size="small"
                      [routerLink]="['/entitlement-client', client.id]"
                    >
                      View
                    </button>
                  </li>
                  <li unity-button-bar-item>
                    <button
                      unity-button
                      size="small"
                      icon="trashcan"
                      [iconOnly]="true"
                      (click)="checkingDeleteClient(client)"
                    ></button>
                  </li>
                </unity-button-bar>
              </td>
            </tr>
          </tbody>
        }
      </unity-table>
    </div>
  }
</unity-container>
